export const useActivityMutations = ({
	onManualReconciliationSuccess = () => {},
	onAssignDriverSuccess = () => {},
	onAssignJobReturnSuccess = () => {},
	onShowRelatedAssignmentsSuccess = () => {},
	onSplitAssignmentSuccess = () => {},
} = {}) => {
	return {
		onManualReconciliation: onManualReconciliationSuccess,
		onAssignDriver: onAssignDriverSuccess,
		onAssignJobReturn: onAssignJobReturnSuccess,
		onShowRelatedAssignments: onShowRelatedAssignmentsSuccess,
		onSplitAssignment: onSplitAssignmentSuccess,
		loading: false,
	};
};
